export default "__VITE_ASSET__oLyghGs1PDEnJljLEyGm7Q__"